module.exports = {
  // Disable de ReduxDevTools
  enableReduxTools: false,
  // Ads API endpoint
  adsAPI: 'https://api.trovit.com',
  // Keywords API endpoint
  keywordApi: 'https://api.trovit.com',
  // Search API base endpoint
  searchApi: 'https://{country_code}.search.api.trovit.com/{vertical_name}',
  // Feedback Campaings API endpoint
  feedbackApi: 'https://es.feedback-campaigns.api.trovit.com',
  // Notification API endpoint
  notificationApi: 'https://api.trovit.com',
  // Notifications Params API endpoint
  notificationsParamsApi: 'http://notifications-params.service.prod.bcn.trovit',
  // Clickout API endpoint
  clickoutApi: 'https://api.trovit.com',
  // Redirect
  redirectApi: 'https://rd.trovit.com',
  // Adjust deeplink base link
  deeplink: 'https://app.adjust.com/egqb12_k6rbm7',
  // Sources API endpoint to save applies
  sourcesApi: 'https://api.trovit.com',
  // Tracking API endpoint for internal tracking
  trackingApi: 'https://api.trovit.com',
  // metrics API endpoint for metrics of the sdk apis
  metricsApi: 'http://127.0.0.1:3000/api/metrics',
  // Facebook App ID:
  facebookHomesAppId: 154099761356072,
  // Google Analytics (Trovit global traffic)
  analyticsGlobalId: 'UA-163198-122',
  analyticsDevelVerticalId: 'UA-163198-204',
  // Google Tag Manager
  TagManagerId: 'GTM-MHZBSWD',
  // Adsense DFP
  dfpNetworkId: '1014363',
  // Sentry logs
  sentryPublicKey: 'https://3b5a4b81cd444854b4bb46309604d55b@sentry.io/203372',
  sentryPrivateKey:
    'https://3b5a4b81cd444854b4bb46309604d55b:e037de7bc79e46868f6657c91b60db3f@sentry.io/203372',
  // Push Notification Server Public Key
  pushNotificationServerPublicKey:
    'BJFfIhYJIx1qtxNbwycJl7RMks_lf1oB38U7u5d70LWdQ0aZHj75RGy_BCwg-ADPPaQoFFsKmadoDiIf-ATQPac',
};



// WEBPACK FOOTER //
// ./parameters/client/config.js